module.exports = __webpack_public_path__ + "img/footer-img-styria.7346f80c.jpg";